var React = require('react');

function OnOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.4 29.4a1.54 1.54 0 0 1-1.5-1.5V1.5c.1-.8.7-1.5 1.5-1.5a1.54 1.54 0 0 1 1.5 1.5V28c0 .8-.6 1.4-1.5 1.4zm0 30.6C13.5 60 2.6 50.9.4 38.5-1.8 26 5.5 13.8 17.6 9.6c.8-.3 1.6.1 1.9.9s-.1 1.6-.9 1.9C7.8 16.2 1.4 26.9 3.3 37.9 5.2 49 15 57 26.4 57c11.5 0 21.2-8 23.1-19.1 1.9-11-4.5-21.8-15.3-25.5-.8-.3-1.2-1.1-.9-1.9s1.1-1.2 1.9-.9C47.4 13.8 54.7 26 52.5 38.5 50.3 50.9 39.3 60 26.4 60z"}));
}

OnOff.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 52.9 60","overflow":"visible"};

module.exports = OnOff;

OnOff.default = OnOff;
